import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('type'),
    validators.requiredString('colorBlockInput.sectionTitle.defaultValue'),
    validators.requiredBoolean('colorBlockInput.isActive'),
    validators.forEach(
        'colorBlockInput.colorSettings',
        validators.compose(
            validators.requiredString('name.defaultValue'),
            validators.requiredColorHex('hex'),
            validators.forEach('sectionImages', validators.requiredUploadFile('variantColorImage'))
        )
    )
);

const useColorBlockValidator = () => useValidator(validator);

export default useColorBlockValidator;
